import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { gql, useLazyQuery, useMutation } from '@apollo/client'
import { useTranslation } from 'react-i18next'
import { message } from 'antd'

import { SyncAccountButtonRender } from './render'

const OSH_ACCOUNT_DOCUMENT_CHECKS = gql`
  query OshAccountDocumentChecks($orderId: ID!) {
    oshAccountDocumentChecks(orderId: $orderId) {
      type
      flow
      code
      present
      error
    }
  }
`

const SYNC_OSH_ACCOUNT_DOCUMENTS = gql`
  mutation SyncOshAccountDocuments($orderId: ID!, $documents: [OshAccountDocumentSelectionInput!]) {
    syncOshAccountDocuments(orderId: $orderId, documents: $documents) {
      success
    }
  }
`

const SyncAccountButton = ({ orderId }) => {
  const { i18n } = useTranslation()
  const [modalOpen, setModalOpen] = useState(false)
  const [pickedKeys, setPickedKeys] = useState(null)

  // network-only: every open is a fresh dry run — osh-account state may have
  // changed since the previous check.
  const [runCheck, { data, loading, error }] = useLazyQuery(OSH_ACCOUNT_DOCUMENT_CHECKS, {
    variables: { orderId },
    fetchPolicy: 'network-only'
  })

  const [syncDocuments, { loading: syncing }] = useMutation(SYNC_OSH_ACCOUNT_DOCUMENTS, {
    onCompleted: () => {
      setModalOpen(false)
      message.success(i18n.t('confirms:accounting.syncAccount.toastStarted'))
    },
    onError: () => message.error(i18n.t('confirms:accounting.syncAccount.toastFailed'))
  })

  const startCheck = () => {
    setPickedKeys(null)
    runCheck()
  }

  const handleOpen = () => {
    setModalOpen(true)
    startCheck()
  }

  return (
    <SyncAccountButtonRender
      modalOpen={modalOpen}
      onOpen={handleOpen}
      onClose={() => setModalOpen(false)}
      onRetry={startCheck}
      pickedKeys={pickedKeys}
      onPick={setPickedKeys}
      onConfirm={(documents) => syncDocuments({ variables: { orderId, documents } })}
      checking={loading}
      syncing={syncing}
      checkFailed={!!error}
      documents={(data && data.oshAccountDocumentChecks) || []}
    />
  )
}

SyncAccountButton.propTypes = {
  orderId: PropTypes.string.isRequired
}

export { SyncAccountButton }
